<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('chairman.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'chairman' }">{{ $t('chairman.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b-img src="https://www2.budaedu.org/official-website-data/chairman/chairman.jpg" fluid></b-img>
        <h5 class="text-center mt-3">本會董事長 密寶法師</h5>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <van-divider
          :style="{ color: '#8a2be2', borderColor: '#8a2be2', 'font-size': '1.5em' }"
        >傳承．承擔</van-divider>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
<p>感恩佛陀 禮敬佛陀</p>
<p>由於佛陀的緣起，讓我們這一期生命得以皈依三寶，學習如來正法，明白諸法究竟本質，趣向無上菩提果位。</p>
<p>佛陀一生示現「八相成道」，即：從兜率天下、託胎、誕生、出家、降魔、成道、轉法輪、入涅槃。此八大聖跡，皆為引導眾生啟發心中的慈悲與智慧，讓心性產生善良、樸實、柔和、包容。</p>
<p>本會深信佛法乃究竟圓滿之教育，希望透過本會提供更多資源與課程，使大眾於學習中培養慈悲與智慧，找到身心安定的方向，趣向菩提之道。</p>
<p>本會主要法務有二：<br>一、印贈法寶，大量印製南傳、漢傳、藏傳佛教法典，免費供養給全世界有緣的剎土，利益十方眾生。<br>二、培育弘法人才，本會舉辦假日佛學院及各類課程，長期培育弘法人才。</p>
<p>感謝諸山長老、諸位大德及社會賢達之護持，亦感謝本會所有董事與同仁之用心，共使法務穩定成長。</p>
<h3 class="text-success font-weight-bold text-center">如來正法遍滿虛空<br>一切有情離苦得樂</h3>
<p class="text-right">財團法人佛陀教育基金會<br>董事長 釋密寶 和南禮敬<br>2025年8月23日</p>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { Divider } from 'vant'
import { ImagePlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(BreadcrumbPlugin)
Vue.use(Divider)
Vue.use(ImagePlugin)

export default {
  i18n,
  name: 'chairman',
  props: {
    // 
  },
  data() {
    return {
      // 
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  },
  metaInfo() {
    return {
      title: this.$t('chairman.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>